export default "__VITE_ASSET__B23Wa_Zl__"